import { RtRequest } from "../RtRequest";
import { AbstractFilters } from "../RtTypes";

export const makeNewRequest = <TFilters extends AbstractFilters>(
  defaultValues?: Partial<RtRequest<TFilters>>,
) => ({
  page: 0,
  pageSize: defaultValues ? defaultValues.pageSize : 10,
  ...defaultValues,
});
